import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import asyncValidate from "./asyncValidatePassword";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { changePassword } from "SettingActions";
import { loginToApp } from "Actions";
import LocaleStrings from "Languages";

class PasswordSetting extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { loading: false, validated: false };
  }

  onFormSubmit(values) {
    // debugger;
    this.setState({ loading: true });

    var valuesToSubmit = {
      ...values,
      appuserid: this.props.session.userid,
      email: this.props.session.emailid,
      eventid: this.props.session.eventid,
    };

    this.props.changePassword(
      this.props.session,
      valuesToSubmit,
      (response) => {
        if (response.error) {
          this.props.showError(
            LocaleStrings.password_setting_form_old_password_error
          );
          this.setState({ loading: false });
        } else {
          values = { ...valuesToSubmit, password: valuesToSubmit.new_password };
          this.props.loginToApp(values, this.props.session, (loginresponse) => {
            if (!loginresponse.success) {
              this.props.showError(COMMON_FAIL_MESSAGE);
              this.setState({ loading: false });
            } else {
              this.props.showSuccess(
                LocaleStrings.password_setting_form_success
              );
              this.props.reset();
              this.setState({ loading: false });
            }
          });
        }
      }
    );
  }

  render() {
    var { handleSubmit, invalid, pristine, submitting, deviceSize } =
      this.props;
    return (
      <div
        className="panel-body settings-container"
        style={{
          height: deviceSize.height - 90,
        }}
      >
        <Row>
          <Col md={8}>
            <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
              <div className="form-group row">
                <label
                  className="control-label col-sm-12"
                  style={{ textAlign: "left" }}
                >
                  <span
                    className="label-mandatory"
                    style={{ fontWeight: 700 }}
                  >{`${LocaleStrings.password_setting_text_update_password_for} - ${this.props.user.email}`}</span>
                </label>
              </div>
              <Field
                name="old_password"
                label={LocaleStrings.password_setting_form_label_old_password}
                placeholder={
                  LocaleStrings.password_setting_form_ph_old_password
                }
                type="password"
                component={this.renderFieldText}
                session={this.props.session}
              />
              <div className="h-divider settings-divider">&nbsp;</div>
              <div className="clearfix">&nbsp;</div>
              <Field
                name="new_password"
                label={LocaleStrings.password_setting_form_label_new_password}
                placeholder={
                  LocaleStrings.password_setting_form_ph_new_password
                }
                type="password"
                component={this.renderFieldText}
              />
              <Field
                name="repeat_new_password"
                label={
                  LocaleStrings.password_setting_form_label_repeat_password
                }
                placeholder={
                  LocaleStrings.password_setting_form_ph_repeat_password
                }
                type="password"
                component={this.renderFieldText}
              />
              <div className="clearfix">&nbsp;</div>
              <Button
                className="btn-custom-blue pull-right"
                loading={this.state.loading}
                type="submit"
                disabled={pristine || invalid || submitting}
              >
                {LocaleStrings.button_change_password}
              </Button>
            </form>
          </Col>
        </Row>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.old_password) {
    errors.old_password =
      LocaleStrings.password_setting_form_validation_old_password_required;
  }

  if (!values.new_password) {
    errors.new_password =
      LocaleStrings.password_setting_form_validation_new_password_required;
  }

  if (values.new_password && !values.repeat_new_password) {
    errors.repeat_new_password =
      LocaleStrings.password_setting_form_validation_repeat_password_required;
  }

  if (values.new_password && values.repeat_new_password) {
    if (values.new_password !== values.repeat_new_password) {
      errors.repeat_new_password =
        LocaleStrings.password_setting_form_validation_repeat_old_password_not_match;
    }
  }

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    serverResponse: state.changePasswordResponse,
    user: state.user,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  changePassword,
  loginToApp,
})(
  reduxForm({
    form: "UpdatePasswordForm",
    validate,
    /*asyncValidate,
    asyncBlurFields:['oldpwd'],*/
    enableReinitialize: true,
  })(PasswordSetting)
);
